import React, { useRef } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ArrowForwardOutlined from "@mui/icons-material/ArrowForwardOutlined";
import Check from "@mui/icons-material/Check";
import ContentCopy from "@mui/icons-material/ContentCopy";
import OpenInNewOutlined from "@mui/icons-material/OpenInNewOutlined";
import { enqueueSnackbar } from "notistack";
import { Link as RouterLink } from "react-router-dom";
import { useCopyToClipboard, useHover } from "usehooks-ts";
import { Path } from "../Path";
import { useGameRules } from "@seabrookstudios/pitch2table";

export const UploadedRules = ({ gameId, url }) => {
  const { data: rules = [] } = useGameRules(gameId);

  const [, copy] = useCopyToClipboard();
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);

  const copyUrlToClipboard = () => {
    copy(url);
    enqueueSnackbar("Url copied to clipboard", { variant: "info" });
  };

  return (
    <ListItem ref={hoverRef}>
      <ListItemText primary="Rules" secondary={url ? `Versions uploaded: ${rules.length}` : "Not uploaded"} />
      {isHover && url && (
        <>
          <ListItemIcon>
            <ListItemButton onClick={copyUrlToClipboard}>
              <ContentCopy />
            </ListItemButton>
          </ListItemIcon>
          <a href={url} target="_blank" rel="noreferrer">
            <ListItemIcon>
              <ListItemButton>
                <OpenInNewOutlined />
              </ListItemButton>
            </ListItemIcon>
          </a>
        </>
      )}
      {url && (
        <ListItemIcon>
          <Box justifyContent="center" alignItems="center" display="flex" flex={1}>
            <Chip icon={<Check />} label="DONE" color="success" />
          </Box>
        </ListItemIcon>
      )}
      <Link to={Path.game(gameId).rules()} component={RouterLink}>
        <ListItemIcon>
          <ListItemButton>
            <ArrowForwardOutlined />
          </ListItemButton>
        </ListItemIcon>
      </Link>
    </ListItem>
  );
};
